<div fxFlex="100" fxFlex.gt-sm="60" fxFlexOffset.gt-sm="20" style="margin-top: 20px;">
    <button routerLink="/display-neu" mat-raised-button color="primary" class="mb-1">
      Neues Display
    </button>
    <mat-card style="margin-top: 20px;">
      <mat-card-header>
        <mat-card-title>
          Alle Displays
        </mat-card-title>
      </mat-card-header>
      <mat-card-content fxLayoutAlign="center" *ngIf="loading">
        <mat-spinner diameter="30" ></mat-spinner>
      </mat-card-content>
      <mat-card-content [hidden]="loading" *ngIf="displays.length > 0">
        <mat-form-field style="width: 100%;">
          <mat-label>
            Suche
          </mat-label>
          <input matInput [formControl]="search">
        </mat-form-field>
  
        <table mat-table class="table table-hover" [dataSource]="displaysFiltered" matSort style="width: 100%;" [hidden]="displaysFiltered.length == 0">
          <ng-container matColumnDef="nummer">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              Display-Nummer
            </th>
            <td mat-cell *matCellDef="let element">
              {{element.nummer}}
            </td>
          </ng-container>

          <ng-container matColumnDef="beschreibung">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              Beschreibung
            </th>
            <td mat-cell *matCellDef="let element">
              {{element.beschreibung | excerpt}}
            </td>
          </ng-container>

          <ng-container matColumnDef="inhalte">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              Inhalte
            </th>
            <td mat-cell *matCellDef="let element">
              {{element.inhalt | excerpt}}
            </td>
          </ng-container>

          <ng-container matColumnDef="bild">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
              Bild
            </th>
            <td mat-cell *matCellDef="let element">
              <img [src]="element.abbildung64" class="img img-thumbnail" style="max-width: 180px;">
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="['nummer', 'beschreibung', 'inhalte', 'bild']"></tr>
          <tr mat-row [routerLink]="'/display/'+row.id" style="cursor: pointer;" *matRowDef="let row; columns: ['nummer', 'beschreibung', 'inhalte', 'bild'];"></tr>
        </table>
        <mat-paginator [pageSizeOptions]="[10, 25, 50]" showFirstLastButtons></mat-paginator>
      </mat-card-content>
      <mat-card-content *ngIf="displays.length == 0 && !loading">
        <div class="alert alert-info">
            Derzeit sind keine Displays angelegt
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  